The details of the created questionnaire.
